/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import LoginModal from './container/LoginModal';

export default LoginModal;
